//utama
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

//form
import Login from './login';
import Utama from './utama';

const url_aplikasi = "http://localhost/hba_api";
const url_file = "http://localhost/hba_file";
const basename = "";

// const url_aplikasi = "https://hba.notebookpedia.com/hba_api";
// const url_file = "https://hba.notebookpedia.com/hba_file";
// const basename = "";

// const url_aplikasi = "https://solidaritasmitra.com/warung/warung_mitra_api";
// const url_file = "https://solidaritasmitra.com/warung/warung_mitra_file";
// const basename = "";

function App() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route
          path="/login"
          element={
            <Login
              aplikasi={url_aplikasi}
              file={url_file}
            />
          }
        />
        <Route
          path="*"
          element={
            <Utama
              aplikasi={url_aplikasi}
              file={url_file}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;